import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import CollectionLogos from '../components/CollectionLogos';
import AboutSection from '../components/AboutSection';
import ExploreCollections from '../components/ExploreCollections';
import LatestCollection from '../components/LatestCollection';
import BathwareSection from '../components/BathwareSection';
import DigitalShowroom from '../components/DigitalShowroom';
import StartJourney from '../components/StartJourney';
import BlogSection from '../components/BlogSection';
import WhyChoose from '../components/WhyChoose';
import Newsletter from '../components/Newsletter';
import Footer from '../components/Footer';
import FloatingActions from '../components/FloatingActions';

export default function Home() {
  return (
    <div className="min-h-screen bg-white text-[#1a1a1a]">
      <Header />
      <main>
        <Hero />
        <CollectionLogos />
        <AboutSection />
        <ExploreCollections />
        <LatestCollection />
        <BathwareSection />
        <DigitalShowroom />
        <StartJourney />
        <BlogSection />
        <WhyChoose />
        <Newsletter />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
